import { QuizCart as hub1375 } from './variants/hub1375';

// const variants = [hub1375, original, hub1408, hub1414, pricingDropdown];
const variants = [hub1375];

export const getCartComponent = (cartVariant = 0) =>
  variants[Number(cartVariant)] || hub1375;
